import type { CSSProperties } from 'react'

export type RoleTone = CSSProperties & {
  '--role-accent': string
  '--role-ink': string
  '--role-soft': string
}

export const roleTones: Record<'groom' | 'bride', RoleTone> = {
  groom: {
    '--role-accent': '#A6AEBF',
    '--role-ink': '#626B7C',
    '--role-soft': 'rgba(166, 174, 191, 0.24)',
  },
  bride: {
    '--role-accent': '#D9B8BE',
    '--role-ink': '#9D6973',
    '--role-soft': 'rgba(217, 184, 190, 0.28)',
  },
}
